import {
    GET_CHAT_DATA_REQUEST,
    GET_CHAT_DATA_SUCCESS,
    GET_CHAT_DATA_FAILURE,
    SAVE_CHAT_REQUEST,
    SAVE_CHAT_SUCCESS,
    SAVE_CHAT_FAILURE,
    GET_USER_CHATS_REQUEST,
    GET_USER_CHATS_SUCCESS,
    GET_USER_CHATS_FAILURE,
    DELETE_CHAT_REQUEST,
    DELETE_CHAT_SUCCESS,
    DELETE_CHAT_FAILURE
} from '../actions/supportAssistant';

const initialState = {
    chats: [],
    currentChat: null,
    loading: false,
    error: null
};

const supportAssistant = (state = initialState, action) => {
    switch (action.type) {
        case GET_CHAT_DATA_REQUEST:
        case SAVE_CHAT_REQUEST:
        case GET_USER_CHATS_REQUEST:
        case DELETE_CHAT_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_CHAT_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                currentChat: action.payload,
                error: null
            };

        case SAVE_CHAT_SUCCESS:
            return {
                ...state,
                loading: false,
                chats: state.chats.map(chat => 
                    chat._id === action.payload._id ? action.payload : chat
                ),
                currentChat: action.payload,
                error: null
            };

        case GET_USER_CHATS_SUCCESS:
            return {
                ...state,
                loading: false,
                chats: action.payload,
                error: null
            };

        case DELETE_CHAT_SUCCESS:
            return {
                ...state,
                loading: false,
                chats: state.chats.filter(chat => chat._id !== action.payload),
                currentChat: state.currentChat?._id === action.payload ? null : state.currentChat,
                error: null
            };

        case GET_CHAT_DATA_FAILURE:
        case SAVE_CHAT_FAILURE:
        case GET_USER_CHATS_FAILURE:
        case DELETE_CHAT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        default:
            return state;
    }
};

export default supportAssistant;